module.exports = __webpack_public_path__ + "static/maars_logo_neon-97101f30efc2f66e07e85d644792633b.svg";